import React from 'react';
import _ from 'lodash';
import { fromJS } from 'immutable';
import ReactHighmaps from 'react-highcharts/dist/ReactHighmaps';
import MapModal from './map_modal';
import map from './mapdata/us-all';

const mapValues = {
  'pro': 'clinton',
  'anti': 'trump',
  'neutral': 'other'
};

const mapColors = ['#244999', '#d22532', '#a8adb4'];
const renderDivs = (data) => {
  let content = _.chain(data).pick('pro', 'anti', 'neutral', 'clinton', 'trump', 'other',)
    .map((value, key) => {
      return `
        <div class="mapdata-tooltip__result">
          ${key}:
          <b>${(value*100).toFixed(2)}%</b>
        </div>
      `;
    }).join('');;

  return content;
};

const MapChart = React.createClass({

  getInitialState() {
    return {
      showModal: false,
      stateData: {}
    };
  },

  getDefaultProps() {
    return {
      data: fromJS({})
    };
  },

  _getDataset() {
    return window.location.pathname.split('/')[3];
  },

  _getColorAxis() {
    const dataset = this._getDataset();

    let dataValues = [{
      from: -0.5,
      to: 0.5,
      color: '#1695a3',
      name: 'pro'
    }, {
      from: 0.6,
      to: 1.5,
      color: '#ff4454',
      name: 'anti'
    }, {
      from: 1.6,
      to: 2.5,
      color: '#a8adb4',
      name: 'neutral'
    }];

    if (dataset === 'presidential-candidates') {
      dataValues = _.map(dataValues, (row, k) => {
        row.color = mapColors[k];
        return _.transform(row, (result, value, key) => {
          result[key] = mapValues[value] || value;
        });
      });
    }

    return dataValues;
  },

  _getMapOptions() {

    const config = {
      chart: {
        spacingBottom: 20,
        backgroundColor: "transparent"
      },
      title: {
        text: ''
      },

      credits: {
        enabled: false
      },

      legend: {
        enabled: true
      },

      mapNavigation: {
        enabled: false,
        enableButtons: false
      },

      colorAxis: {
        dataClasses: this._getColorAxis()
      },

      tooltip: {
        useHTML: true,
        backgroundColor: "rgba(255,255,255,1)",
        formatter: function() {
          return `<div class="mapdata-tooltip">
                    <h5>${this.point.name}</h5>
                    ${ renderDivs(this.point.stateData) }
                  </div>`
        }
      },

      plotOptions: {
        map: {
          states: {
            hover: {
              color: '#dadada'
            }
          }
        },
        series: {
          point: {
            events: {
              click: (ev) => {

                const state = ev.point.stateData.state;
                const states = [];
                let stateKey = -1;

                _.each(map.features, (val, key) => {
                  states.push(val.properties['postal-code'])
                  stateKey = _.indexOf(states, state);
                });

                const stateName = map.features[stateKey].properties.name
                ev.point.stateData.stateName = stateName;

                this.setState({
                  showModal: true,
                  stateData: ev.point.stateData
                });
              }
            }
          }
        }
      },

      series: [{
        data: [],
        borderColor: 'white',
        mapData: map,
        joinBy: 'postal-code',
        dataLabels: {
          enabled: true,
          color: '#ffffff',
          format: '{point.postal-code}',
          style: {
            textTransform: 'uppercase',
            textShadow: false
          }
        },
        cursor: 'pointer'
      }]
    };

    return config
  },

  _renderModal() {
    return( <MapModal onHide={this.closeModal} showModal={this.state.showModal} stateData={this.state.stateData} />)
  },

  _mappingMapData(data) {
    const config = this._getMapOptions();
    const dataset = this._getDataset();

    if (!(_.has(_.last(data), 'other')) && (dataset === 'presidential-candidates')) {
      delete config.colorAxis.dataClasses[2]
    }

    if( !_.isEmpty(data) ) {
      const keysBy = _.keyBy(data, 'state');
      const keys = _.keys(keysBy);

      _.each(config.series[0].mapData.features, (mapPoint) => {
        if (mapPoint.properties['postal-code']) {
          const postalCode = mapPoint.properties['postal-code'];
          const i = _.indexOf(keys, postalCode);

          config.series[0].data.push({
            stateData: data[i],
            value: data[i].maxIndex,
            'postal-code': postalCode
          });
        }
      });

      return (
        <ReactHighmaps config={config} />
      )
    }
  },

  render() {
    const data = this.props.data.toJS();
    return (
      <div id='highmaps-container' className="highmaps-container">
        {this._mappingMapData(data)}
        {this._renderModal()}
      </div>
    );
  },

  closeModal() {
    this.setState({ showModal: false });
  }

});

export default MapChart;


/** WEBPACK FOOTER **
 ** ./src/components/charts/map/index.js
 **/